import GameType from './types/GameType';
import SessionStorage from '@/client/utils/storage/SessionStorage';

const getEventData = (event: GameType['event']): GameType | null =>
  SessionStorage.getItem(event, null);

export default getEventData;
